import axios from "axios";

const api = axios.create({
    baseURL: 'https://api.transfermypayment.com',
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {

        const user = localStorage.getItem("user");
        // const {user}= Userauthcontexthooks();

        if (user) {
            config.headers.Authorization = `Bearer ${user}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,

    (error) => {

        if (error.response?.status === 401) {

            localStorage.clear();

            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);

export default api;